// extracted by mini-css-extract-plugin
export default {"block":"ColumnBlock_block__5W6Yj","title":"ColumnBlock_title__y8N7i"};